import { useEffect, useState } from 'react';
import { GraduationCap, ExternalLink, Download, BookOpen } from 'lucide-react';
import { notify } from '../../components/Notify';
import { minhasMatriculasEadApi, baixarMeuComprovanteApi } from '../../api';
import { FUNEMG_EAD_URL } from '../../config';
import funemgLogo from '../../assets/funemg-icone.png';
import './funemg.css';

export default function FunemgEad() {
    const [matriculas, setMatriculas] = useState(null); // null = carregando
    const [baixandoId, setBaixandoId] = useState(null);

    useEffect(() => {
        let vivo = true;
        minhasMatriculasEadApi()
            .then((res) => { if (vivo) setMatriculas(res?.data?.matriculas || []); })
            .catch(() => { if (vivo) setMatriculas([]); });
        return () => { vivo = false; };
    }, []);

    const abrirSite = () => {
        if (!FUNEMG_EAD_URL) return notify('O link do site da FUNEMG ainda não foi configurado.');
        window.open(FUNEMG_EAD_URL, '_blank', 'noopener');
    };

    const baixarComprovante = async (cursoId, titulo) => {
        setBaixandoId(cursoId);
        let url = null;
        try {
            const res = await baixarMeuComprovanteApi({ cursoId });
            const blob = new Blob([res.data], { type: res.data?.type || 'image/png' });
            url = URL.createObjectURL(blob);
            const nome = String(titulo || 'funemg').trim().replace(/\s+/g, '_');
            const a = document.createElement('a');
            a.href = url; a.download = `comprovante_${nome}.png`;
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
        } catch (err) {
            let msg = 'Não foi possível baixar o comprovante.';
            try { const t = await err?.response?.data?.text?.(); if (t) msg = JSON.parse(t).message || msg; } catch { /* corpo não-JSON */ }
            notify(msg);
        } finally {
            if (url) URL.revokeObjectURL(url);
            setBaixandoId(null);
        }
    };

    return (
        <div className="ueb-page">
            <header className="ueb-page-head">
                <span className="ueb-page-ico"><GraduationCap size={22} /></span>
                <div>
                    <h1 className="ueb-page-title">FUNEMG EAD</h1>
                    <p className="ueb-page-sub">Seus cursos e comprovante de matrícula.</p>
                </div>
            </header>

            <section className="ueb-fn-hero">
                <div className="ueb-fn-hero-txt">
                    <img src={funemgLogo} alt="FUNEMG" className="ueb-fn-hero-logo" />
                    <h2 className="ueb-fn-hero-title">Bem-vindo ao ensino à distância da FUNEMG</h2>
                    <p className="ueb-fn-hero-sub">Sua carteira UEB dá acesso aos cursos da FUNEMG. Assista às aulas quando quiser e baixe seu comprovante de matrícula aqui mesmo.</p>
                    <button className="ueb-fn-hero-btn" onClick={abrirSite}>
                        <ExternalLink size={16} /> Abrir site da FUNEMG
                    </button>
                </div>
                <div className="ueb-fn-hero-art" aria-hidden="true">
                    <svg viewBox="0 0 280 220" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="232" cy="44" r="48" fill="#ffffff" opacity="0.08" />
                        <circle cx="48" cy="182" r="30" fill="#ffffff" opacity="0.08" />
                        <rect x="58" y="78" width="154" height="98" rx="11" fill="#ffffff" />
                        <rect x="42" y="178" width="186" height="13" rx="6.5" fill="#ffffff" opacity="0.92" />
                        <rect x="72" y="92" width="126" height="70" rx="7" fill="#16a34a" opacity="0.14" />
                        <circle cx="135" cy="127" r="23" fill="#ffffff" />
                        <path d="M129 116 l17 11 -17 11 z" fill="#16a34a" />
                        <g transform="translate(170,40)">
                            <path d="M0 15 L28 4 L56 15 L28 26 Z" fill="#ffffff" />
                            <path d="M13 20 L13 32 C13 37 43 37 43 32 L43 20" stroke="#ffffff" strokeWidth="3.5" fill="none" strokeLinecap="round" />
                            <line x1="56" y1="15" x2="56" y2="31" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
                            <circle cx="56" cy="33" r="3.5" fill="#ffffff" />
                        </g>
                        <circle cx="40" cy="72" r="4" fill="#ffffff" opacity="0.75" />
                        <circle cx="242" cy="150" r="5" fill="#ffffff" opacity="0.6" />
                    </svg>
                </div>
            </section>

            {matriculas === null ? (
                <div className="pcard" style={{ padding: 40, textAlign: 'center' }}>
                    <span className="pspin" style={{ color: 'var(--p-accent)' }} />
                </div>
            ) : matriculas.length === 0 ? (
                <div className="ueb-empty pcard">
                    <span className="ueb-empty-ico"><BookOpen size={26} /></span>
                    <strong>Você ainda não tem matrícula no EAD</strong>
                    <p>Ao emitir a carteirinha marcando “Matricular na FUNEMG”, sua matrícula aparece aqui.</p>
                </div>
            ) : (
                <div className="ueb-fn-cursos">
                    <h2 className="ueb-fn-h2">Seus cursos</h2>
                    {matriculas.map((m) => (
                        <div key={m.cursoId} className="pcard ueb-fn-curso">
                            <div className="ueb-fn-curso-info">
                                <span className="ueb-fn-curso-ico"><GraduationCap size={20} /></span>
                                <div className="ueb-fn-curso-txt">
                                    <strong>{m.cursoTitulo}</strong>
                                    {m.status && <span className="ueb-fn-curso-status">{m.status}</span>}
                                </div>
                            </div>
                            <button className="pbtn pbtn--soft" onClick={() => baixarComprovante(m.cursoId, m.cursoTitulo)} disabled={baixandoId === m.cursoId}>
                                {baixandoId === m.cursoId ? <span className="pspin" /> : <><Download size={16} /> Comprovante</>}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
